import {
  ValidationResolver,
  ValidationResolverContext,
  ValidationResolutionResult,
} from '../../models/kyc-validation.model';

/**
 * Resolver para problemas de documento duplicado
 * 
 * Quando o documento já foi usado por outro usuário, não há como
 * resolver automaticamente - o usuário precisa fazer um novo KYC
 * com um documento diferente.
 */
export class UniqueDocumentValueResolver implements ValidationResolver {
  validationType = 'unique_document_value';

  canResolve(context: ValidationResolverContext): boolean {
    return context.validation.validation === this.validationType;
  }

  async resolve(
    context: ValidationResolverContext
  ): Promise<ValidationResolutionResult> {
    console.log('[Resolver] Resolving unique_document_value...');
    console.log('[Resolver] Details:', context.validation.details);

    // Documento duplicado - não pode resolver automaticamente
    // O componente que chama deve iniciar um novo KYC
    return {
      resolved: false,
      requiresNewKyc: true,
      message: 'Document already in use. User must provide a different document.',
    };
  }
}
